import { useEffect, useState } from "react";
import { APISERVICE } from "../../../services/api.service";
import Seeker from "../reports/Seeker";
import { TableJustifications } from "./TableJustifications";
import { initialPagination } from "data/constants";


export function Justification (){
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState(initialPagination);
    const [filters, setFilters] = useState(null)

    useEffect(() => {
        getReports(1, {
            startDate: '',
            endDate: '',
            ci: '',
        })
    },[])

    const getReports = async (pageNumber = 1, paramsSeeker = filters ) => {
        try {
          setLoading(true);
          const url = 'verificacion/justification?'
          let params = `page=${pageNumber}`;
          const { success, data, pagination } = await APISERVICE.post(url,params,paramsSeeker);
            if(success){  
              setReports(data);
              setPagination(pagination)
            }else{
              setReports([]);
            }
        } catch (error) {
          
        } finally {
          setLoading(false);
        }
      }
    const searchJustifications = (body) => {
        getReports(pagination?.currentPage, body);
        setFilters(body);
    }

    return (
        <div className="contenedor">
               <div className='title-enable-teacher fs-3 mb-3'>Justificaciones</div>
              <Seeker searchTeacherReports={searchJustifications}/>
              <TableJustifications reports={reports} loading={loading} pagination={pagination} getReports={getReports}/>
        </div>
    )
}